import React, { useState, useEffect } from "react";

function About() {
  return (
    <div className="about-page">
      <div className="title-container title">
        <h2>About</h2>
      </div>
      <div className="about-content">
        Diese Webseite ist eine Projektarbeit, die mit Hilfe von interaktiven Mitteln, auf die Problematiken unserer Wegwerfgesellschaft fokussiert. Man kann somit die Webseite mit hochgeladenen Bilder vermüllen und diese anschließend in verschiedene Behälter sortieren. Bilder können so ähnlich zu einem sozialem Netzwerk anonym geliked und kommentiert werden. Von Jonathan Haudenschild</div>
    </div>
  );
}

export default About;
